<template>
    <section>
        <compWrapper
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
            theme="primary"
        >
            <vForm
                class="padding-top-15 padding-left-15 padding-right-15"
                :style="`margin-bottom: -10px;`"
                :labelWidth="120"
                :model="warehouseBaseInfo"
                ref="myForm"
            >
                <vRow>
                    <vCol span="12">
                        <vFormItem
                            :style="
                                type != 'add'
                                    ? 'margin-bottom: 5px;'
                                    : 'position: relative;'
                            "
                            :label="
                                $t('fbb.inbound.warehouse_type', {
                                    defaultValue: '仓库类型',
                                })
                            "
                            prop="warehouseType"
                            :rules="type != 'add' ? '' : required"
                        >
                            <div v-if="type == 'add'">
                                <vSelect
                                    @on-change="handleWarehouseType"
                                    v-model="warehouseBaseInfo.warehouseType"
                                >
                                    <vOption
                                        v-for="item in getWarehouseTypes"
                                        :key="item.value"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                                <div
                                    class="color-error"
                                    style="
                                        position: absolute;
                                        left: 120px;
                                        top: 25px;
                                    "
                                >
                                    {{ selectText }}
                                </div>
                            </div>
                            <div class="font-bold" v-else>
                                {{ warehouseTypeLabel || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :style="
                                type == 'query' ? 'margin-bottom: 5px;' : ''
                            "
                            :label="
                                $t('fbb.warehouse.warehouse_name', {
                                    defaultValue: '仓库名称',
                                })
                            "
                            prop="warehouseName"
                            :rules="type === 'query' ? '' : required"
                        >
                            <vInput
                                v-if="type !== 'query'"
                                v-model="warehouseBaseInfo.warehouseName"
                            />
                            <div v-else class="font-bold">
                                {{ warehouseBaseInfo.warehouseName }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <compFormEdit
                        v-if="type !== 'query'"
                        class="margin-layout margin-top-0"
                        ref="formbase"
                        :formdata="getBase"
                        v-model="warehouseBaseInfo"
                    ></compFormEdit>
                    <compFormQuery
                        v-else
                        class="margin-layout margin-top-0"
                        :formdata="getBase"
                        :value="warehouseBaseInfo"
                        placeholder="--"
                    ></compFormQuery>
                </vRow>
            </vForm>
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.address_information', {
                    defaultValue: '地址信息',
                })
            "
            theme="info"
        >
            <compFormEdit
                v-if="type !== 'query'"
                class="margin-layout"
                ref="formaddress"
                :formdata="getAddress"
                v-model="warehouseAddress"
            ></compFormEdit>
            <compFormQuery
                v-else
                class="margin-layout"
                :formdata="getAddress"
                placeholder="--"
                :value="warehouseAddress"
            >
            </compFormQuery>
        </compWrapper>
        <!-- <compWrapper
            :title="
                $t('fbb.warehouse.customer_list', { defaultValue: '客户列表' })
            "
            theme="info"
            v-if="
                (warehouseBaseInfo.warehouseType != 4 || type === 'query') &&
                handleAuth('fbb.warehouse.organizationset')
            "
        >
            <compCustomer
                class="margin-layout"
                ref="warehouseOrgIds"
                :data="warehouseOrgChannels"
            ></compCustomer>
        </compWrapper> -->
        <compWrapper
            v-if="warehouseBaseInfo.warehouseType == 4"
            :title="
                this.$t('fbb.warehouse.onsite_channel_list', {
                    defaultValue: 'ONSITE仓渠道列表',
                })
            "
            theme="info"
        >
            <compAccount
                class="margin-layout"
                ref="channelIds"
                :data="warehouseOrgChannels"
            ></compAccount>
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.other_information', {
                    defaultValue: '其他信息',
                })
            "
            theme="info"
        >
            <compFormEdit
                v-if="type !== 'query'"
                class="margin-layout"
                :formdata="getOtherInfo"
                v-model="formData"
            >
            </compFormEdit>
            <compFormQuery
                v-else
                class="margin-layout"
                :formdata="getOtherInfo"
                placeholder="--"
                :value="formData"
            >
            </compFormQuery>
            <!-- <vButtonGroup slot="footer">
				<vButton
					v-for="item in getStatusBtns"
					:key="item.name"
					@click="item.run"
					:theme="item.theme"
				>{{item.name}}</vButton>
			</vButtonGroup> -->
            <div
                class="text-right margin-top-20 padding-right-20"
                v-show="type != 'query'"
            >
                <vButton theme="primary" @click="save">{{
                    $t("global.common.update_OK", { defaultValue: "确定" })
                }}</vButton>
                <vButton class="margin-left-10" @click="cancel">{{
                    $t("global.common.operation_cancel", {
                        defaultValue: "取消",
                    })
                }}</vButton>
            </div>
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.operate_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
            v-if="type === 'query'"
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="getLogcolumns"
            ></compLog>
        </compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show = false"
            @on-confirm="getDetail"
        >
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps.props"
                v-on="modalProps.on"
            />
        </compModal>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import {
    HttpSaveManageWare,
    HttpWarehouseListGetDetail,
} from "@/service/basicdata";
import mixin from "../manageware/mixin";
import compAccount from "./account";
import Clipboard from "clipboard";
export default {
    props: ["activeid", "querytype"],
    mixins: [mixin],
    components: {
        compLog: () => import("@components/templates/log"),
        compModal: () => import("@components/templates/modal"),
        compAccount,
    },
    data() {
        return {
            loading: false,
            type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
            formData: {
                businessType: [],
            },
            warehouseTypeLabel: "",
            warehouseBaseInfo: {
                hoseOrgId: this.$store.state.organization.id,
                hoseOrgName: this.$store.state.organization.name,
                attributes: [],
                active: "NO",
            },
            warehouseAddress: {
                country: "US",
            },
            warehouseOrgChannels: [],
            // warehouseOrgIds: [],
            // channelIds: [],
            logList: [], //log,
            modalProps: {
                show: false,
            },
            selectText: "",
            isTransfer: false,
            zoneClosingTime: "",
            attachesList: [],
        };
    },
    created() {
        this.getDetail();
    },
    computed: {
        ...mapGetters("common", [
            "getCurrencyList",
            "getCountryList",
            "getStateList",
        ]),
        ...mapGetters("dictionary", [
            "getBillcusorgList",
            "getBillcusWareList",
            "getAreaList",
        ]),
        required() {
            return [
                {
                    required: true,
                    message: this.$t("global.common.required", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ];
        },
        /**
         * 根据状态显示不同按钮
         */
        getStatusBtns() {
            const btn = [
                {
                    name: this.$t("global.common.save", {
                        defaultValue: "保存",
                    }),
                    theme: "primary",
                    show: this.type !== "query",
                    run: this.save,
                },
                {
                    name: this.$t("global.common.return", {
                        defaultValue: "返回",
                    }),
                    theme: "default",
                    show: true,
                    run: this.cancel,
                },
            ];
            return btn.filter((item) => item.show);
        },

        getBase() {
            return [
                {
                    label: this.$t("fbb.warehouse.warehouse_code", {
                        defaultValue: "仓库代码",
                    }),
                    key: "wahouseCode",
                    query: this.type != "add",
                },
                {
                    label: this.$t("fbb.warehouse.property", {
                        defaultValue: "附加属性",
                    }),
                    key: "attributes",
                    tag: "vCheckBox",
                    props: {
                        strict: false,
                    },
                    options: this.getWarehouseAttrs.map((item) => {
                        return {
                            label: item.label,
                            trueValue: item.value,
                        };
                    }),
                    required: false,
                    render: () => {
                        return this.getWarehouseAttrs.map((json) => {
                            const bool =
                                this.warehouseBaseInfo.attributes.indexOf(
                                    json.value
                                ) > -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                },
                // {
                // 	label: this.$t('fbb.warehouse.owner_org', { defaultValue: "所属管理方" }),
                // 	key: "hoseOrgName",
                // 	query: true
                // },
                {
                    label: this.$t("global.common.currency", {
                        defaultValue: "币种",
                    }),
                    key: "currency",
                    tag: "vSelect",
                    options: this.getCurrencyList,
                    render: (h) => {
                        return this.warehouseBaseInfo.currency || "--";
                    },
                },
                {
                    label: this.$t("fbb.warehouse.status", {
                        defaultValue: "活动状态",
                    }),
                    key: "active",
                    tag: "vSwitch",
                    props: {
                        trueValue: "YES",
                        falseValue: "NO",
                    },
                },
                {
                    label: this.$t("fbb.warehouse.closing_time", {
                        defaultValue: "截单时间（UTC）",
                    }),
                    key: "closingTime",
                    tag: "vDatepicker",
                    props: {
                        format: "HH:MM:SS",
                        // confirm:false,
                    },
                    required: false,
                    render: () => {
                        if (
                            this.warehouseBaseInfo.closingTime &&
                            this.zoneClosingTime
                        ) {
                            return (
                                this.warehouseBaseInfo.closingTime +
                                "/" +
                                this.zoneClosingTime
                            );
                        } else if (this.warehouseBaseInfo.closingTime) {
                            return this.warehouseBaseInfo.closingTime;
                        } else {
                            return "--";
                        }
                    },
                },

                /* {
                label: "是否需要新品审核",
                key: "aduit",
                tag: 'vSwitch',
                props: {
                    trueValue: 'YES',
                    falseValue: 'NO',
                }
                }, */
                {
                    label: this.$t("fbb.warehouse.receiving_time", {
                        defaultValue: "收货时间",
                    }),
                    key: "reserveTime",
                    tag: "vDatepicker",
                    props: {
                        format: "yy-mm-dd ~ yy-mm-dd",
                        confirm: false,
                    },
                },
                {
                    label: this.$t("fbb.warehouse.dock", {
                        defaultValue: "签到DOCK",
                    }),
                    key: "dockNum",
                    tag: "vInput",
                    props: {
                        placeholder: "请输入1-5、8、11-15",
                    },
                },
                {
                    label: this.$t("fbb.warehouse.latest_confirmation", {
                        defaultValue: "退货最晚确认时间天数",
                    }),
                    key: "returnLastDay",
                    tag: "InputNumber",
                    props: {
                        min: 0,
                        style: "width:100%",
                    },
                },
                {
                    label: this.$t("fbb.manageware.bussiness_email", {
                        defaultValue: "仓库作业邮箱",
                    }),
                    key: "contactEmail",
                    tag: "vInput",
                    required: false,
                    props: {},
                },
                {
                    label: this.$t("fbb.manageware.sendAttention", {
                        defaultValue: "送仓注意事项",
                    }),
                    key: "deliveryRemark",
                    tag: "vTextarea",
                    required: false,
                    render: () => {
                        return this.warehouseBaseInfo.deliveryRemark || "--";
                    },
                },
                {
                    label: this.$t("fbb.warehouse.capacity_cbm", {
                        defaultValue: "分配库容(CBM)",
                    }),
                    key: "capacity",
                    required: false,
                    tag: "vInput",
                },
                {
                    label: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    key: "description",
                    tag: "vTextarea",
                    required: false,
                },
                {
                    label: this.$t("fbb.headlogistics.attachment", {
                        defaultValue: "附件",
                    }),
                    key: "attachesList",
                    tag: "div",
                    required: false,
                    render: () => {
                        let attachesListDom;
                        if (this.attachesList.length > 0) {
                            attachesListDom = (
                                <div>
                                    {this.attachesList.map((item, index) => (
                                        <div key={index}>
                                            <a
                                                style="color:skyblue"
                                                href={item.fileurl}
                                                target="_blank"
                                            >
                                                {item.filename}
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            );
                        } else {
                            attachesListDom = "--";
                        }
                        return attachesListDom;
                    },
                },
            ];
        },
        //地址信息
        getAddress() {
            return [
                {
                    label: this.$t("global.common.country", {
                        defaultValue: "国家",
                    }),
                    key: "country",
                    tag: "vSelect",
                    options: this.getCountryList,
                    render: (h) => {
                        // console.log(this.warehouseAddress.country, this.getCountryList);
                        return this.warehouseAddress.country || "--";
                    },
                },
                {
                    label: this.$t("erp.b2c.state_province", {
                        defaultValue: "州/省",
                    }),
                    key: "state",
                    tag:
                        this.warehouseAddress &&
                        this.warehouseAddress.country === "US"
                            ? "vSelect"
                            : "vInput",
                    options: this.getStateList,
                    render: (h) => {
                        return this.warehouseAddress.state || "--";
                    },
                },
                {
                    label: this.$t("erp.b2c.city", { defaultValue: "城市" }),
                    key: "city",
                },
                {
                    label: this.$t("erp.b2c.zip_code", {
                        defaultValue: "邮编",
                    }),
                    key: "postal",
                    formItem: {
                        rules: {
                            required: true,
                            validator(rule, value, callback) {
                                // console.log(value, 'value')
                                callback(
                                    !value || value.length < 5
                                        ? new Error(
                                              this.$t(
                                                  "fbb.warehouse.length_ge_5",
                                                  {
                                                      defaultValue:
                                                          "不得低于5位",
                                                  }
                                              )
                                          )
                                        : undefined
                                );
                            },
                        },
                    },
                },
                {
                    label: this.$t("erp.b2border.addressone", {
                        defaultValue: "详细地址1",
                    }),
                    key: "address",
                    render: () => {
                        let address = this.warehouseAddress.address
                            ? this.warehouseAddress.address
                            : "--";
                        let postal = this.warehouseAddress.postal
                            ? this.warehouseAddress.postal
                            : "--";
                        let city = this.warehouseAddress.city
                            ? this.warehouseAddress.city
                            : "--";
                        let state = this.warehouseAddress.state
                            ? this.warehouseAddress.state
                            : "--";
                        let country = this.warehouseAddress.country
                            ? this.warehouseAddress.country
                            : "--";
                        let addRessResult =
                            address +
                            " " +
                            postal +
                            "," +
                            city +
                            "," +
                            state +
                            "," +
                            country;
                        return (
                            <div>
                                {addRessResult}
                                <a title="复制地址">
                                    <Icon
                                        type="ios-copy"
                                        size="18"
                                        class="tag-copy"
                                        data-clipboard-text={addRessResult}
                                        onClick={this.copyAddress}
                                    />
                                </a>
                            </div>
                        );
                    },
                },
                {
                    label: this.$t("erp.b2border.addresstwo", {
                        defaultValue: "详细地址2",
                    }),
                    key: "address2",
                    required: false,
                },
                {
                    label: this.$t("erp.b2border.linkman", {
                        defaultValue: "联系人",
                    }),
                    key: "linkman",
                    required: false,
                },
                {
                    label: this.$t("erp.b2c.phone", { defaultValue: "电话" }),
                    key: "phone",
                    required: false,
                },
                {
                    label: this.$t("global.common.email", {
                        defaultValue: "邮箱",
                    }),
                    key: "email",
                    required: false,
                },
                {
                    label: this.$t("global.common.mobile", {
                        defaultValue: "移动电话",
                    }),
                    key: "mobilePhone",
                    required: false,
                },
            ];
        },
        getOtherInfo() {
            return [
                {
                    label: this.$t("global.common.depotApiType", {
                        defaultValue: "推送仓库系统",
                    }),
                    key: "depotApiType",
                    tag: "vSelect",
                    options: this.getWarehouseSys,
                    required: false,
                },
                // {
                //     label: this.$t("global.common.onsite_warehouse_address", {
                //         defaultValue: "onsite仓所在仓库",
                //     }),
                //     key: "onsiteWarehouseId",
                //     tag: "vSelect",
                //     options: this.getBillcusWareList.filter((item) => {
                //         return (
                //             item.attach.warehouseType == 1 &&
                //             item.attach.active == 1
                //         );
                //     }),
                //     required: false,
                // },
                {
                    label: this.$t("global.common.areaId", {
                        defaultValue: "仓库所属区域",
                    }),
                    key: "areaId",
                    tag: "vSelect",
                    required: false,
                    options: this.getAreaList,
                },
                {
                    label: this.$t("global.common.relWarehouseId", {
                        defaultValue: "关联服务仓/虚拟仓",
                    }),
                    key: "relWarehouseId",
                    // 选择中转仓才展示
                    show: this.isTransfer,
                    tag: "vSelect",
                    props: {
                        filterable: true,
                    },
                    required: false,
                    options: this.getBillcusWareList.filter((item) => {
                        return (
                            item.attach.warehouseType == 1 &&
                            item.attach.active == 1
                        );
                    }),
                },
                {
                    label: this.$t("global.common.cartonQty", {
                        defaultValue: "日均收柜数量",
                    }),
                    key: "cartonQty",
                    tag: "vInputNumber",
                    props: {
                        min: 0,
                        precision: 0,
                    },
                    required: false,
                },
                {
                    label: this.$t("global.common.businessType", {
                        defaultValue: "业务模式",
                    }),
                    key: "businessType",
                    tag: "vCheckBox",
                    props: {
                        strict: false,
                    },
                    render: (h) => {
                        let text = (this.formData.businessType || [])
                            .map((value) => {
                                return this.getBusinessType.filter((item) => {
                                    return item.trueValue == value;
                                })[0].label;
                            })
                            .join(",");
                        return text || "--";
                    },
                    options: this.getBusinessType,
                    required: false,
                },
            ];
        },
        // 操作历史
        getLogcolumns() {
            return [
                {
                    title: this.$t("global.log.operator", {
                        defaultValue: "操作人",
                    }),
                    key: "opUserName",
                },
                {
                    title: this.$t("global.log.action", {
                        defaultValue: "操作类型",
                    }),
                    key: "opAction",
                    // render:(h,{row})=>{
                    //     return <div>{row.carrierServiceCode} ({row.carrierCode} {row.carrierServiceName})</div>
                    // }
                },

                {
                    title: this.$t("fbb.accountmanage.param", {
                        defaultValue: "更改字段",
                    }),
                    key: "changeField",
                },
                {
                    title: this.$t("global.common.before_value", {
                        defaultValue: "更改前值",
                    }),
                    key: "beforeChange",
                },
                {
                    title: this.$t("global.common.after_value", {
                        defaultValue: "更改后值",
                    }),
                    key: "afterChange",
                },
                {
                    title: this.$t("global.log.date", {
                        defaultValue: "操作时间",
                    }),
                    key: "opAt",
                },
            ];
        },
        getBusinessType() {
            return [
                {
                    label: "B2B",
                    trueValue: 1,
                },
                {
                    label: "B2C",
                    trueValue: 2,
                },
            ];
        },
        getWarehouseTypes() {
            return [
                {
                    value: "1",
                    label: "Service Warehouse(服务仓)",
                    text: this.$t(
                        "fbb.basicdata.warehouse_type_service_remark",
                        { defaultValue: "记录库存流水，库存根据单据产生变动" }
                    ),
                },
                {
                    value: "2",
                    label: this.$t("fbb.warehouse.fba_warehouse", {
                        defaultValue: "FBA仓",
                    }),
                },
                // {
                //     value: '4',
                //     label: this.$t('fbb.warehouse.onsite_warehouse', { defaultValue: 'onsite仓库'}),
                // },
                {
                    value: "5",
                    label: "Virtual Warehouse(虚拟仓)",
                    text: this.$t(
                        "fbb.basicdata.warehouse_type_virtual_remark",
                        {
                            defaultValue:
                                "记录库存流水，但可用库存及预留库存不根据单据变动",
                        }
                    ),
                },
                {
                    value: "6",
                    label: "Transfer Warehouse(中转仓)",
                    text: null,
                },
            ];
        },
    },
    methods: {
        handleWarehouseType(val) {
            if (val !== 0 && !val) return;
            // 中转仓
            if (val == 6) {
                this.isTransfer = true;
            }
            this.warehouseBaseInfo.warehouseType = val;
            this.selectText = this.getWarehouseTypes.filter((item) => {
                return item.value === val;
            })[0].text;
        },
        //获取计划单详情
        getDetail() {
            if (this.type === "add") return;
            this.loading = true;
            HttpWarehouseListGetDetail({ id: this.id }).then(
                (res) => {
                    const data = res.data || {};
                    this.loading = false;
                    this.warehouseBaseInfo = {
                        ...data.warehouseBaseInfo,
                        hoseOrgId: this.warehouseBaseInfo.hoseOrgId,
                        hoseOrgName: this.warehouseBaseInfo.hoseOrgName,
                    };
                    this.warehouseBaseInfo.returnLastDay =
                        res.data.returnLastDay;
                    this.zoneClosingTime = res.data.zoneClosingTime;
                    if (
                        this.warehouseBaseInfo.receiveStartTime &&
                        this.warehouseBaseInfo.receiveEndTime
                    ) {
                        this.warehouseBaseInfo.reserveTime =
                            this.warehouseBaseInfo.receiveStartTime +
                            "~" +
                            this.warehouseBaseInfo.receiveEndTime;
                    }
                    // this.warehouseType = data.warehouseBaseInfo.warehouseType;
                    this.warehouseAddress = data.warehouseAddress || {};
                    // this.$set(this, "warehouseAddress", data.warehouseAddress || {});
                    this.warehouseOrgChannels = data.warehouseOrgChannels;
                    //this.attachesList = res.data.attachesList
                    this.formData = {
                        id: data.id,
                        depotApiType: data.depotApiType,
                        onsiteWarehouseId: data.onsiteWarehouseId,
                        areaId: data.areaId,
                        businessType: data.businessType,
                        onsiteWarehouseId: data.onsiteWarehouseId,
                        relWarehouseId: data.relWarehouseId,
                        cartonQty: data.cartonQty,
                    };
                    this.logList = data.carrierRuleLogs;
                    this.warehouseTypeLabel = this.getWarehouseTypes.filter(
                        (item) => {
                            return (
                                item.value ==
                                this.warehouseBaseInfo.warehouseType
                            );
                        }
                    )[0].label;
                    // 中转仓类型
                    if (res.data.warehouseBaseInfo.warehouseType == 6) {
                        this.isTransfer = true;
                    }
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(
                        this.$t(err.langCode, { defaultValue: err.message })
                    );
                }
            );
        },

        //更新单据数据
        async save() {
            let flag = true;
            await this.$refs.myForm.validate((valid) => {
                return (flag = valid);
            });
            if (!flag) return;
            await this.$refs.formbase.validate((valid) => {
                return (flag = valid);
            });
            if (!flag) return;
            await this.$refs.formaddress.validate((valid) => {
                return (flag = valid);
            });
            if (!flag) return this.$VMessage.error(flag);
            if (this.warehouseBaseInfo.capacity) {
                let capacity = Number(this.warehouseBaseInfo.capacity);
                if (isNaN(capacity) || capacity < 0) {
                    return this.$VMessage.error(
                        this.$t("fbb.warehouse.data_ge_0", {
                            defaultValue: "请填写大于0的数字！",
                        })
                    );
                }
            }
            this.loading = true;
            HttpSaveManageWare({
                ...this.formData,
                warehouseBaseInfo: this.warehouseBaseInfo,
                warehouseAddress: this.warehouseAddress,
                warehouseOrgChannels: this.handlerOrgChannels(),
            })
                .then(() => {
                    this.$store.commit(
                        "dictionary/clearStore",
                        "billcusWareList"
                    );
                    this.cancel();
                })
                .catch((err) => {
                    this.loading = false;
                    const message =
                        (err.message || "").indexOf("permission") > -1
                            ? this.$t("erp.code.800100012", {
                                  defaultValue: "无操作权限",
                              })
                            : err.message;
                    this.$VMessage.error(
                        this.$t(err.langCode, { defaultValue: message })
                    );
                });
        },
        //合并仓库组织
        handlerOrgChannels() {
            const result = {};
            const findOrgData = (id) =>
                this.getBillcusorgList.find((item) => item.value == id);
            const orgIds =
                (this.$refs.warehouseOrgIds &&
                    this.$refs.warehouseOrgIds.targetKeys) ||
                [];
            const channelIds =
                (this.$refs.channelIds &&
                    this.$refs.channelIds.getTargetData) ||
                [];
            orgIds.forEach((orgId) => {
                result[orgId] = {
                    orgId,
                };
            });
            // console.log(channelIds,'channelIdschannelIds')
            // console.log(orgIds,'orgIdsorgIds')
            channelIds.forEach((item) => {
                const orgData = findOrgData(item.orgId);
                item.orgCode = orgData.attach.code;
            });
            for (let key in result) {
                const orgData = findOrgData(key);
                if (orgData) {
                    result[key].orgCode = orgData.attach.code;
                }
            }
            if (channelIds.length > 1) {
                return channelIds;
            } else {
                return Object.values(result);
            }
            // console.log(channelIds)
            // return Object.values(result) || channelIds;
        },
        cancel() {
            this.$router.push({
                name: "basicdataWarehouseList",
            });
        },
        //复制地址
        copyAddress(param) {
            var clipboard = new Clipboard(".tag-copy");
            clipboard.on("success", (e) => {
                this.$VMessage.success("复制成功");
                // 释放内存
                clipboard.destroy();
            });
            clipboard.on("error", (e) => {
                // 不支持复制
                console.log("该浏览器不支持自动复制");
                // 释放内存
                clipboard.destroy();
            });
        },
    },
};
</script>
